<div *ngIf="showLoader$" class="loader_cont">
    
  <div class="DSA_wb_overlay" style="position: fixed;z-index: 1000; background: rgba(0, 0, 0, 0.5);"></div>                    
  <div class="loading-spinner" style="z-index: 1001;">
      <div class="loading-spinner-inner">
          <div></div>
      </div>
  </div>
</div> 